import { petBirthdayElements } from '@flows/configs/petHealthV2/steps/elements/petBirthday'
import { fragmentStep } from '@flows/configs/shared/stepFragments'
import type { StepConfigParams } from '@flows/configs/types'

const pet_birthday = (params: StepConfigParams) =>
  fragmentStep(petBirthdayElements(params), params, 'pet_gender')

export default pet_birthday
